// extracted by mini-css-extract-plugin
module.exports = {"button":"AddButton_button__1Cr2y","icon":"AddButton_icon__1DkBD"};